import axios from 'axios';

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
}

export interface ApiUser {
  id: number;
  guid: string;
  name: string;
  email: string;
  access_token: string;
  industries: string;
  companies: string;
  created_at: string;
}

export interface CreateUserRequest {
  name: string;
  email: string;
  industries: number[] | string;
  companies: number[] | string;
}

export interface UpdateUserRequest {
  name?: string;
  email?: string;
  industries?: number[] | string;
  companies?: number[] | string;
}

class ApiService {
    private async handleResponse<T>(response: Response) {
        return response;
    }

    async getUsers() {
        try {
            const response:any = await axios.get(`/api/users`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
            throw error;
        }
    }

    async createUser(userData: CreateUserRequest) {
        try {
            const response = await axios.post('/api/users', userData); // Não precisa body nem headers
            return response.data;
        } catch (error) {
            console.error('Erro ao criar usuário:', error);
            throw error;
        }
    }
    
    async updateUser(guid: string, userData: UpdateUserRequest) {
        try {
            const response = await axios.put(`/api/users/${guid}`, userData); // Só passa o objeto direto
            return response;
        } catch (error) {
            console.error('Erro ao atualizar usuário:', error);
            throw error;
        }
    }
    
    async deleteUser(guid: string) {
        try {
            const response = await axios.delete(`/api/users/${guid}`); // Só passa a URL
            return response;
        } catch (error) {
            console.error('Erro ao deletar usuário:', error);
            throw error;
        }
    }
}

export const apiService = new ApiService();